module.exports = __webpack_public_path__ + "img/1477212240.c2aa01a2.jpg";